import { render, staticRenderFns } from "./CreateTicketTask.vue?vue&type=template&id=471ef484&scoped=true"
import script from "./CreateTicketTask.vue?vue&type=script&lang=js"
export * from "./CreateTicketTask.vue?vue&type=script&lang=js"
import style0 from "./CreateTicketTask.vue?vue&type=style&index=0&id=471ef484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471ef484",
  null
  
)

export default component.exports